import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, } from 'react-router-dom';
import VoiceChat from '../../../components/Chat/VoiceChat';
import Cookie from '../../../utils/Cookie';
import { CallWithAuth } from '../../../actions/apiAction';
import { GET_CREATOR_DETAILS } from '../../../utils/apiUrl';
import LiveAvatar from '../../../components/VideoChat/VideoChat';
import PayrollModal from '../../../components/Modals/ShowPayrollModal';



export default function VideoCall() {
    const { search } = useLocation();
    const [userDetails, setUserDetails] = useState({});
    const query = new URLSearchParams(search);
    const userId = query.get("id");
    const name = query.get("name");
    const video = query.get("video");
    const chatId = Cookie.getCookie('activeChatId');
    const [isBackPressed, setIsBackPressed] = useState(false);
    const wakeLockRef = useRef(null);

    const requestWakeLock = async () => {
        try {
            if ("wakeLock" in navigator) {
                wakeLockRef.current = await navigator.wakeLock.request("screen");
                console.log("Screen Wake Lock Activated");
                wakeLockRef.current.addEventListener("release", () => {
                    console.log("Screen Wake Lock Released");
                });
            } else {
                console.log("Wake Lock API not supported");
            }
        } catch (err) {
            console.log("Wake lock error:", err);
        }
    };

    const releaseWakeLock = async () => {
        try {
            if (wakeLockRef.current) {
                await wakeLockRef.current.release();
                wakeLockRef.current = null;
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        requestWakeLock();
        return () => {
            releaseWakeLock();
        };
    }, []);
    const getUserDetails = async () => {
        let responce = await CallWithAuth("GET", GET_CREATOR_DETAILS(userId));
        if (responce.data) {
            setUserDetails(responce?.data);
        }
    };

    useEffect(() => {
        userId && getUserDetails();
    }, [userId])

    useEffect(() => {
        const handleBack = () => {
            console.log("[Parent] Back button pressed");

            // Trigger state
            setIsBackPressed(true);

            // Push state again to prevent immediate navigation
            window.history.pushState(null, "", window.location.href);
        };

        // Push initial state (IMPORTANT)
        window.history.pushState(null, "", window.location.href);

        window.addEventListener("popstate", handleBack);

        return () => {
            window.removeEventListener("popstate", handleBack);
        };
    }, []);

    const fullname = `${userDetails?.first_name ?? ""} ${userDetails?.last_name ?? ""}`.trim();
    const profilePicture = userDetails?.profile_picture_url;

    return (
        <>
            <Helmet>
                <title>Call</title>
            </Helmet>
            <div className="main-body calling-screen p-0 child-div-beta-branding">
                {video === "true" && <div className="beta-branding"><img src="/images/beta-branding.svg" alt="" /></div>}
                {
                    video === "true" ?
                        <LiveAvatar
                            chatId={chatId}
                            userId={userId}
                            name={fullname}
                            profilePic={profilePicture}
                            isBackPressed={isBackPressed}
                        />
                        :
                        <VoiceChat
                            chatId={chatId}
                            userId={userId}
                            name={fullname}
                            profilePic={profilePicture}
                            isBackPressed={isBackPressed}
                        />

                }
            </div>

        </>
    );
}

